import React, { PureComponent } from 'react';
import cn from 'classnames'
import {connect} from'react-redux'
import injectSheet from 'react-jss'
import {UnstyledLink} from "../Widgets/Link"
import {openDropdown, closeDropdown, toggleMobileMenu} from "../../actions"
import Transition from 'react-transition-group/Transition'
import {TweenLite} from 'gsap'
import {canUseDom} from "../../utils/dom"
import chevron from '../../img/icons/chevron.svg'
import SVGSymbol from '../SVGSymbol'
import {genderEmpty} from "../../utils/gender"

const TRANSITION_DURATION_SECONDS = 0.25;

class NavItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    componentWillMount() {
        if(canUseDom) document.addEventListener('click', this._onOutsideClick, false);
    }

    componentWillUnmount() {
        if(canUseDom) document.removeEventListener('click', this._onOutsideClick, false);
    }

    _onOutsideClick = (e) => {
        const {open, url, handleClose} = this.props
        if(!open) return;
        handleClose(url);
    }

    _handleDropdown = (e) => {
        const {open, url, handleClose, handleOpen} = this.props
        if(open) {
            handleClose(url);
            this.setState({ open: false });
        } else {
            handleOpen(url);
            this.setState({ open: true });
        }
        this._preventDefault(e)
    }

    _toggleMobileMenu = () => {
        const { toggleMobileMenu } = this.props;
        toggleMobileMenu()
    }

    _preventDefault = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    _onExiting = (node) => {
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {height: '0', display: 'none'})
    }

    _onEntering = (node) => {
        const {subNav = []} = this.props
        let dropDownHeight = subNav.length * 34
        if (window.outerWidth >= 768) {
            dropDownHeight += 20
        } else {
            dropDownHeight += 6
        }
        TweenLite.set(node, {display: 'block', height: '0%'})
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {height: `${dropDownHeight}`})
    }

    _getUrlWithGender = (url, gender) => {
        if(!gender || gender === genderEmpty) return url;
        return url + "?g=" + gender;
    }

    render () {
        const {classes, classNames = {}, label, selected, url, subNav = [], open, gender, mobileMenu = false} = this.props;
        return (
            <li className={cn(classes.mainNavItem, classNames.mainNavItem, { selected })} onMouseEnter={!mobileMenu && this._handleDropdown}>
                { subNav.length > 0 && (
                    <div className={cn(classes.labelContainer, open && classes.menuSelected)}>
                        <UnstyledLink className={classes.label} link={{url: url ? this._getUrlWithGender(url, gender) : "", label: label}}></UnstyledLink>
                        <div className={cn(classes.labelIcon, open && classes.iconRotate)} onClick={mobileMenu && this._handleDropdown}>
                            <SVGSymbol icon={chevron} />
                        </div>
                    </div>
                )}
                { subNav.length === 0 && <UnstyledLink className={classes} link={{url: url ? this._getUrlWithGender(url, gender) : "", label: label}}></UnstyledLink> }
                { subNav.length > 0 && (
                    <Transition in={open} timeout={TRANSITION_DURATION_SECONDS*1000} onEntering={this._onEntering} onExiting={this._onExiting}>
                        {(state) => (
                            <div className={cn(classes.subNav, 'mainSubNav')} onClick={this._toggleMobileMenu}>
                                {subNav.map(item => (
                                    <UnstyledLink className={classes} key={item.url + item.title} link={{url: this._getUrlWithGender(item.url, gender), label: item.title}}></UnstyledLink>
                                ))}
                            </div>
                        )}
                    </Transition>
                )}
            </li>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        open: state.dropdown.open && state.dropdown.id === props.url,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleOpen: ( id ) => dispatch(openDropdown(id)),
        handleClose: ( id ) => dispatch(closeDropdown(id)),
        toggleMobileMenu: () => dispatch(toggleMobileMenu()),
    }
}

export default injectSheet((theme) => ({
    mainNavItem: {
        height: 'auto',
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        cursor: 'pointer',
        [theme.breakpoint("tablet")]: {
            margin: `0`,
            height: 56,
            display: 'flex',
        },
        zIndex: 1,
        '&:hover': {
            zIndex: 2
        },
        "& a, & span": {
            padding: `0 20px`,
            color: theme.colors.subTitle,
            textTransform: 'uppercase',
            fontFamily: theme.font.familyBold,
            fontSize: theme.getRemValue( 12 ),
            letterSpacing: 0.68,
            textDecoration: "none",
            display: 'flex',
            height: 54,
            alignItems: 'center',
            justifyContent: 'flex-start',
            transition: 'opacity 300ms',
            backgroundColor: theme.colors.white,
            [theme.breakpoint("tablet")]: {
                justifyContent: 'center'
            },
            "&:hover": {
                textDecoration: 'none',
                color: theme.colors.primary,
                [theme.breakpoint("tablet")]: {
                    color: 'rgba(70, 70, 70, 1)',
                }
            },
            [theme.breakpoint('mobile')]: {
                fontSize: theme.getRemValue(13),
            },
        },
        '&.selected a, &.selected span': {
            opacity: 1,
            color: theme.colors.black,
        },
        "&.strong": {
            fontWeight: 'bold'
        },
        "&.mobile": {
            display: "flex",
            [theme.breakpoint("tablet")]: {
                display: 'none',
            }
        },
        '&.notMobile': {
            display: "none",
            [theme.breakpoint("tablet")]: {
                display: "flex",
            }
        }
    },
    labelContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    labelIcon: {
        display: 'flex',
        height: 54,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 54,
        "& svg": {
            color: theme.colors.black,
            width: 11,
            height: 11,
            transition: 'transform 300ms'
        },
        [theme.breakpoint("tablet")]: {
            display: "none",
        }
    },
    iconRotate: {
        "& svg": {
            transform: 'rotate(180deg)'
        }
    },
    label: {
        ...theme.font.link,
        display: "inline-block",
        textDecoration: "none",
        color: theme.colors.black,
        position: "relative",
        paddingRight: "0.6em",
        marginLeft: 0,
        whiteSpace: 'nowrap',
        letterSpacing: '0.8px',
        cursor: 'pointer',
    },
    menuSelected: {
        '& a': {
            color: theme.colors.black
        },
        [theme.breakpoint("tablet")]: {
            '&:after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                height: 3,
                left: 0,
                right: 0,
                backgroundColor: '#000'
            }
        }
    },
    subNav: {
        display: 'none',
        backgroundColor: theme.colors.white,
        color: theme.colors.black,
        top: '100%',
        left: 0,
        minWidth: 160,
        cursor: 'pointer',
        overflow: 'hidden',
        zIndex: theme.zIndex.dropdown,
        [theme.breakpoint("tablet")]: {
            position: 'absolute',
            boxShadow: '0px 5px 10px rgba(0,0,0,0.1)'
        },
        "& li": {
            margin: '0'
        },
        "& a, & div": {
            color: theme.colors.black,
            fontFamily: theme.font.family,
            padding: [0, 20],
            display: 'block',
            width: '100%',
            position: 'relative',
            height: 34,
            lineHeight: '24px',
            textTransform: 'none',
            textAlign: 'left',
            fontSize: theme.getRemValue(14),
            fontWeight: 300,
            opacity: 1,
            textDecoration: 'none',
            '&:hover, &.selected': {
                color: theme.colors.primary
            },
            '&:first-child': {
                marginTop: 0
            },
            '&:last-child': {
                marginBottom: 0
            },
            [theme.breakpoint("tablet")]: {
                lineHeight: '34px',
                padding: [0, 24],
                '&:first-child': {
                    marginTop: 10
                },
                '&:last-child': {
                    marginBottom: 10
                }
            },
        },
    }
}))(connect(mapStateToProps, mapDispatchToProps)(NavItem))



// WEBPACK FOOTER //
// ./src/components/UniversalNav/NavItem.js